function initFavoritesDisplay() {
	let $favoritesLink = $('.js-favorites');
	$favoritesLink.append('<span class="js-favorites-count site-header__favorites-count">0</span>');

	updateFavoritesCount();

	$(window).on('favorites', function() {
		updateFavoritesCount();
	});
}

function updateFavoritesCount() {
	let $favoritesDisplay = $('.js-favorites-count');

	if (localStorage.getItem('favorite-products')|| localStorage.getItem('favorite-projects')) {
		let productIds = JSON.parse(localStorage.getItem('favorite-products'));
		let projectIds = JSON.parse(localStorage.getItem('favorite-projects'));
		let favoriteCount = 0;

		if (Array.isArray(productIds)) {
			favoriteCount = productIds.length;
		}
		if (Array.isArray(projectIds)) {
			favoriteCount =favoriteCount + projectIds.length;
		}

		$favoritesDisplay.text(`${favoriteCount}`);
	}
}

export function init() {
	initFavoritesDisplay();
}
